import { Injectable } from '@angular/core';

@Injectable()
export class AppConstants {
  static SYSTEM_ENTRY_START_YEAR = 2019;
  static RE_REGISTRATION_ENTRY_START_YEAR = 2014;

  static INSTITUTION_TYPES = [
    { value: 'UNIVERSITY', option: 'University' },
    { value: 'COLLEGE', option: 'College' },
    { value: 'INSTITUTE', option: 'Institute' },
    { value: 'OTHER', option: 'Other' }
  ];

  static DEFAULT_COUNTRY = {
    id: '100',
    name: 'India'
  };

  static FIXED_STAGE_IDS = [1, 2, 3, 4, 5];
  static ADMISSION_DONE_STAGE_ID = 5;
  static FIXED_REASON_IDS = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40
  ];
  static FIXED_SR_MAPPING_IDS = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40
  ];

  static categories = [
    {
      name: 'GENERAL',
      value: 'GENERAL'
    },
    {
      name: 'OBC',
      value: 'OBC'
    },
    {
      name: 'SC',
      value: 'SC'
    },
    {
      name: 'ST',
      value: 'ST'
    },
    {
      name: 'EWS',
      value: 'EWS'
    },
    {
      name: 'OTHERS',
      value: 'OTHERS'
    }
  ];

  static processStatusesAdminForListStudents = [
    {
      name: 'All Process',
      value: ''
    },
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Processable',
      value: 'PROCESSABLE'
    },
    {
      name: 'Processed',
      value: 'PROCESSED_BY_EMPLOYEE'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Document Required',
      value: 'DOCUMENT_REQUIRED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static processStatusesHeadCounselorForListStudents: any = [
    {
      name: 'All Process',
      value: ''
    },
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Processable',
      value: 'PROCESSABLE'
    },
    {
      name: 'Processed',
      value: 'PROCESSED_BY_CENTER'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Document Required',
      value: 'DOCUMENT_REQUIRED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static processStatusesCounselorForProcessStudents: any = [
    {
      name: 'Processable',
      value: 'PROCESSABLE'
    },
    {
      name: 'Processed',
      value: 'PROCESSED_BY_COUNSELOR'
    },
    {
      name: 'Processed By Head Counselor',
      value: 'PROCESSED_BY_HEAD_COUNSELOR'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    }
  ];

  static processStatusesHeadCounselorForProcessStudents: any = [
    {
      name: 'Processable',
      value: 'PROCESSABLE'
    },
    {
      name: 'Processed',
      value: 'PROCESSED_BY_HEAD_COUNSELOR'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    }
  ];

  static processStatusesHeadCounselorCounselorStudentForProcessStudents: any = [
    {
      name: 'Processable',
      value: 'PROCESSED_BY_COUNSELOR'
    },
    {
      name: 'Processed',
      value: 'PROCESSED_BY_HEAD_COUNSELOR'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    }
  ];

  static processStatusesAdminForProcessStudents: any = [
    {
      name: 'Not Verified',
      value: 'PROCESSED_BY_EMPLOYEE'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Document Required',
      value: 'DOCUMENT_REQUIRED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static processStatusesForScholarship: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static processStatusesAdminCenterForProcessStudents: any = [
    {
      name: 'Not Verified',
      value: 'PROCESSED_BY_CENTER'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Document Required',
      value: 'DOCUMENT_REQUIRED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static processTypes = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Processable',
      value: 'PROCESSABLE'
    },
    {
      name: 'Processed By Head Counselor',
      value: 'PROCESSED_BY_HEAD_COUNSELOR'
    },
    {
      name: 'Processed By Counselor',
      value: 'PROCESSED_BY_COUNSELOR'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Document Required',
      value: 'DOCUMENT_REQUIRED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static employementStatuses = [
    {
      name: 'Employed',
      value: 'EMPLOYED'
    },
    {
      name: 'Un-Employed',
      value: 'UN_EMPLOYED'
    }
  ];

  static verificationStatues: any = [
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    },
    {
      name: 'Document Required',
      value: 'DOCUMENT_REQUIRED'
    }
  ];

  static filterVerficationStatuses: any = [
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    },
    {
      name: 'Document Required',
      value: 'DOCUMENT_REQUIRED'
    }
  ];

  static filterProcessTypes: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Processable',
      value: 'PROCESSABLE'
    },
    {
      name: 'Processing',
      value: 'PROCESSING_BY_CENTER'
    },
    {
      name: 'Processed',
      value: 'PROCESSED'
    }
  ];

  static universityVerificationStatues: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static universityVerificationStatuesFilter: any = [
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static supportTicketStatuses: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Resolved',
      value: 'RESOLVED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static allticketsTypes: any = [
    {
      name: 'Admission Ticket',
      value: 'ADMISSION_TICKET'
    },
    {
      name: 'Re-Registration Ticket',
      value: 'RE_REGISTRATION_TICKET'
    },
    {
      name: 'Examination Ticket',
      value: 'EXAMINATION_TICKET'
    },
    {
      name: 'Marksheet Ticket',
      value: 'MARKSHEET_TICKET'
    },
    {
      name: 'Transcript Ticket',
      value: 'TRANSCRIPT_TICKET'
    },
    {
      name: 'Revaluation Ticket',
      value: 'REVALUATION_TICKET'
    },
    {
      name: 'Migration Ticket',
      value: 'MIGRATION_TICKET'
    },
    {
      name: 'Original Degree Ticket',
      value: 'ORIGINAL_DEGREE_TICKET'
    },
    {
      name: 'E-Learning Ticket',
      value: 'E_LEARNING_TICKET'
    },
    {
      name: 'Other Ticket',
      value: 'OTHER_TICKET'
    }
  ];

  static centerTicketTypes: any = [
    {
      name: 'Admission Ticket',
      value: 'ADMISSION_TICKET'
    },
    {
      name: 'Lead Ticket',
      value: 'LEAD_TICKET'
    },
    {
      name: 'Other Ticket',
      value: 'OTHER_TICKET'
    }
  ];

  static centerNotificationTypes: any = [
    {
      name: 'Admission',
      value: 'ADMISSION'
    },
    {
      name: 'Other',
      value: 'OTHER'
    }
  ];

  static issueStatuses: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Payment Received',
      value: 'PAYMENT_RECEIVED'
    },
    {
      name: 'Out For Delivery',
      value: 'OUT_FOR_DELIVERY'
    },
    {
      name: 'Delivered',
      value: 'DELIVERED'
    },
    {
      name: 'Payment Not Required',
      value: 'PAYMENT_NOT_REQUIRED'
    }
  ];

  static issuePaymentStatuses: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Success',
      value: 'SUCCESS'
    },
    {
      name: 'Failed',
      value: 'FAILED'
    }
  ];

  static receiptStatus: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Accepted',
      value: 'ACCEPTED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static admissionTypes: any = [
    {
      name: 'FRESH ADMISSION',
      value: 'FRESH_ADMISSION',
      default_semester: 1
    },
    {
      name: 'LATERAL ENTRY',
      value: 'LATERAL_ENTRY',
      default_semester: 3
    },
    {
      name: 'CREDIT TRANSFER',
      value: 'CREDIT_TRANSFER',
      default_semester: 5
    },
    {
      name: 'MIGRATION',
      value: 'MIGRATION',
      default_semester: 1
    }
  ];

  static year: any = [
    {
      name: '2009',
      value: '2009'
    },
    {
      name: '2010',
      value: '2010'
    },
    {
      name: '2011',
      value: '2011'
    },
    {
      name: '2012',
      value: '2012'
    },
    {
      name: '2013',
      value: '2013'
    },
    {
      name: '2014',
      value: '2014'
    },
    {
      name: '2015',
      value: '2015'
    },
    {
      name: '2016',
      value: '2016'
    },
    {
      name: '2017',
      value: '2017'
    },
    {
      name: '2018',
      value: '2018'
    },
    {
      name: '2019',
      value: '2019'
    },
    {
      name: '2020',
      value: '2020'
    },
    {
      name: '2021',
      value: '2021'
    },
    {
      name: '2022',
      value: '2022'
    },
    {
      name: '2022',
      value: '2022'
    },
    {
      name: '2023',
      value: '2023'
    },
    {
      name: '2024',
      value: '2024'
    },
    {
      name: '2025',
      value: '2025'
    }
  ];

  static months: any = [
    {
      name: 'January',
      value: 1
    },
    {
      name: 'February',
      value: 2
    },
    {
      name: 'March',
      value: 3
    },
    {
      name: 'April',
      value: 4
    },
    {
      name: 'May',
      value: 5
    },
    {
      name: 'June',
      value: 6
    },
    {
      name: 'July',
      value: 7
    },
    {
      name: 'August',
      value: 8
    },
    {
      name: 'September',
      value: 9
    },
    {
      name: 'October',
      value: 10
    },
    {
      name: 'November',
      value: 11
    },
    {
      name: 'December',
      value: 12
    }
  ];

  static unRemovedYears: any = [1, 2, 3];

  static removedYears: any = [2, 3];

  static sessionTypes: any = [
    {
      name: 'Calendar',
      value: 'CAL'
    },
    {
      name: 'Academic',
      value: 'ACD'
    }
  ];

  static subjectTypes: any = [
    {
      name: 'Theory',
      value: 'THEORY'
    },
    {
      name: 'Practical',
      value: 'PRACTICAL'
    },
    {
      name: 'Minor Project',
      value: 'MINOR_PROJECT'
    },
    {
      name: 'Major Project',
      value: 'MAJOR_PROJECT'
    },
    {
      name: 'Dissertation',
      value: 'DISSERTATION'
    },
    {
      name: 'Training',
      value: 'TRAINING'
    },
    {
      name: 'Seminar',
      value: 'SEMINAR'
    }
  ];

  static transferredStudentStatuses: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Transferred',
      value: 'TRANSFERRED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static filterBackMarkStatusForUniversity: any = [
    {
      name: 'Marked',
      value: 'MARKED_BY_CENTER'
    },
    {
      name: 'Rejected',
      value: 'REJECTED_BY_UNIVERSITY'
    }
  ];

  static questionTypes: any = {
    objective: {
      question_type: ['objective']
    },
    subjective: {
      question_type: ['subjective']
    }
  };

  static noOfPeriods = 8;

  static semester_nos = [1, 2, 3, 4, 5, 6, 7, 8];
  static govIdTypes: any = [
    {
      name: 'AADHAAR CARD',
      value: 'AADHAAR'
    },
    {
      name: 'DRIVING LICENCE',
      value: 'DRIVING_LICENCE'
    },
    {
      name: 'VOTER ID',
      value: 'VOTER_ID'
    },
    {
      name: 'PASSPORT',
      value: 'PASSPORT'
    },
    {
      name: 'OTHER',
      value: 'OTHER'
    }
  ];
  static maritalStatues: any = [
    {
      name: 'SINGLE',
      value: 'SINGLE'
    },
    {
      name: 'MARRIED',
      value: 'MARRIED'
    },
    {
      name: 'DIVORCED',
      value: 'DIVORCED'
    },
    {
      name: 'WIDOWED',
      value: 'WIDOWED'
    },
    {
      name: 'SEPARATED',
      value: 'SEPARATED'
    }
  ];
  static genders: any = [
    {
      name: 'MALE',
      value: 'MALE'
    },
    {
      name: 'FEMALE',
      value: 'FEMALE'
    },
    {
      name: 'OTHER',
      value: 'OTHER'
    }
  ];

  static category: any = [
    {
      name: 'Fresh Admission',
      value: 'FRESH_ADMISSION'
    },
    {
      name: 'Lateral Entry',
      value: 'LATERAL_ENTRY'
    },
    {
      name: 'Credit Transfer',
      value: 'CREDIT_TRANSFER'
    }
  ];

  static divisions: any = [
    {
      name: 'First',
      value: 1
    },
    {
      name: 'Second',
      value: 2
    },
    {
      name: 'Third',
      value: 3
    }
  ];

  static religions: any = [
    {
      name: 'HINDU',
      value: 'HINDU'
    },
    {
      name: 'MUSLIM',
      value: 'MUSLIM'
    },
    {
      name: 'CHRISTIAN',
      value: 'CHRISTIAN'
    },
    {
      name: 'JAIN',
      value: 'JAIN'
    },
    {
      name: 'BUDDHIST',
      value: 'BUDDHIST'
    },
    {
      name: 'SIKH',
      value: 'SIKH'
    },
    {
      name: 'OTHERS',
      value: 'OTHERS'
    }
  ];

  static nationalities: any = [
    {
      name: 'INDIAN',
      value: 'INDIAN'
    },
    {
      name: 'OTHERS',
      value: 'OTHERS'
    }
  ];

  static transactionTypes: any = [
    {
      name: 'NEFT',
      value: 'NEFT'
    },
    {
      name: 'DD',
      value: 'DD'
    },
    {
      name: 'IMPS',
      value: 'IMPS'
    },
    {
      name: 'UPI',
      value: 'UPI'
    },
    {
      name: 'Cheque Deposit',
      value: 'CHEQUE'
    },
    {
      name: 'Bank Cash Deposit',
      value: 'BANK_CASH_DEPOSIT'
    },
    {
      name: 'Cash',
      value: 'CASH'
    },
    {
      name: 'Other',
      value: 'OTHER'
    }
  ];

  static banks: any = [
    {
      name: 'Axis Bank',
      value: 'AXIS'
    },
    {
      name: 'ICICI Bank',
      value: 'ICICI'
    },
    {
      name: 'State Bank of India (SBI)',
      value: 'SBI'
    },
    {
      name: 'Central Bank of India (CBI)',
      value: 'CBI'
    },
    {
      name: 'HDFC Bank',
      value: 'HDFC'
    },
    {
      name: 'IDFC Bank',
      value: 'IDFC'
    },
    {
      name: 'Punjab National Bank (PNB)',
      value: 'PNB'
    },
    {
      name: 'Canara Bank',
      value: 'CANARA'
    },
    {
      name: 'Other Bank',
      value: 'OTHER'
    }
  ];

  static receiptStatuses: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Accepted',
      value: 'ACCEPTED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static years: any = [
    {
      name: '2025',
      value: '2025'
    },
    {
      name: '2024',
      value: '2024'
    },
    {
      name: '2023',
      value: '2023'
    },
    {
      name: '2022',
      value: '2022'
    },
    {
      name: '2021',
      value: '2021'
    }
  ];

  static getDaysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  static days = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday'
  ];

  static attendanceTypes: any = [
    {
      name: 'Present',
      value: 'P'
    },
    {
      name: 'On Duty',
      value: 'OD'
    },
    {
      name: 'Weekly Off',
      value: 'S'
    },
    {
      name: 'Holiday',
      value: 'H'
    },
    {
      name: 'Restricted Holiday',
      value: 'RH'
    },
    {
      name: 'Casual Leave',
      value: 'CL'
    },
    {
      name: 'Paid Leave',
      value: 'P/CL'
    },
    {
      name: 'Medical Leave',
      value: 'ML'
    },
    {
      name: 'Compensatory Off',
      value: 'CO'
    },
    {
      name: 'Absent',
      value: 'A'
    },
    {
      name: 'Leave Without Pay',
      value: 'LWP'
    }
  ];

  static studentAttendanceTypes: any = [
    {
      name: 'Present',
      value: 'PRESENT'
    },
    {
      name: 'Absent',
      value: 'ABSENT'
    },
    {
      name: 'Leave',
      value: 'LEAVE'
    }
  ];

  static borrowedBookLimit = 5;

  static ratings: any = [
    {
      name: 'Exceeds Expectations',
      value: 'Exceeds Expectations'
    },
    {
      name: 'Meets Expectations',
      value: 'Meets Expectations'
    },
    {
      name: 'Needs Improvements',
      value: 'Needs Improvements'
    },
    {
      name: 'Unacceptable',
      value: 'Unacceptable'
    }
  ];

  static bloodGroups: any = [
    {
      name: 'A+',
      value: 'A+'
    },
    {
      name: 'A-',
      value: 'A-'
    },
    {
      name: 'B+',
      value: 'B+'
    },
    {
      name: 'B-',
      value: 'B-'
    },
    {
      name: 'AB+',
      value: 'AB+'
    },
    {
      name: 'AB-',
      value: 'AB-'
    },
    {
      name: 'O+',
      value: 'O+'
    },
    {
      name: 'O-',
      value: 'O-'
    }
  ];

  static attendance_years: any = [
    {
      name: '2025',
      value: '2025'
    },
    {
      name: '2024',
      value: '2024'
    },
    {
      name: '2023',
      value: '2023'
    },
    {
      name: '2022',
      value: '2022'
    },
    {
      name: '2021',
      value: '2021'
    }
  ];

  static office_location_latitude = 28.6064602;
  static office_location_longitude = 77.0809699;
  static vehicleTypes: any = [
    // {
    //   name: 'Luxury Bus',
    //   value: 'LUXURY_BUS'
    // },
    {
      name: 'Standard Bus',
      value: 'STANDARD_BUS'
    }
    // {
    //   name: 'Mini Bus',
    //   value: 'MINI_BUS'
    // },
    // {
    //   name: 'Small Vans',
    //   value: 'SMALL_VANS'
    // },
    // {
    //   name: 'Large Vans',
    //   value: 'LARGE_VANS'
    // },
    // {
    //   name: 'Mini Cab',
    //   value: 'MINI_CAB'
    // },
    // {
    //   name: 'SUV Cab',
    //   value: 'SUV_CAB'
    // }
  ];

  static occupancyTypes: any = [1, 2, 3, 4, 5, 6];

  static feeKeys: any = [
    'rcf',
    'tuition_fee',
    'academic_security_fee',
    'erp_pdp_fee',
    'registration_fee',
    'prospectus_fee',
    'examination_fee',
    'alumni_council_charges',
    'digital_skill_course_charges',
    'placement_cell_charges',
    'science_and_tech_charges',
    'sports_facilities_charges',
    'annual_day_charges',
    'university_tshirt_charges'
  ];

  static disabilities: any = [
    {
      name: 'PHYSICAL',
      value: 'PHYSICAL'
    },
    {
      name: 'SENSORY',
      value: 'SENSORY'
    },
    {
      name: 'INTELLECTUAL',
      value: 'INTELLECTUAL'
    },
    {
      name: 'DEVELOPMENTAL',
      value: 'DEVELOPMENTAL'
    },
    {
      name: 'MENTAL',
      value: 'MENTAL'
    },
    {
      name: 'INVISIBLE',
      value: 'INVISIBLE'
    }
  ];

  static academic_security_fee: number = 5000;

  static transactionModes: any = [
    {
      name: 'Cash',
      value: 'CASH'
    },
    {
      name: 'Online',
      value: 'ONLINE'
    },
    {
      name: 'UPI',
      value: 'UPI'
    },
    {
      name: 'Cheque',
      value: 'CHEQUE'
    },
    {
      name: 'Demand Draft',
      value: 'DEMAND_DRAFT'
    },
    {
      name: 'Adjust',
      value: 'ADJUST'
    }
  ];

  static feeComponentKeys: any = [
    'academic_security_fee',
    'rcf',
    'tuition_fee',
    'erp_pdp_fee',
    'registration_fee',
    'prospectus_fee',
    'examination_fee',
    'alumni_council_charges',
    'digital_skill_course_charges',
    'placement_cell_charges',
    'science_and_tech_charges',
    'sports_facilities_charges',
    'annual_day_charges',
    'university_tshirt_charges'
  ];

  static actualHostelComponentKeys: any = [
    'actual_caution_charge',
    'actual_mess_charge',
    'actual_security_charge',
    'actual_room_charge'
  ];

  static discountHostelComponentKeys: any = [
    'caution_charges',
    'mess_charges',
    'security_charges',
    'room_charges'
  ];

  static diversities: any = [
    {
      name: 'Students from University outside State',
      value: 'STUDENTS_FROM_UNIVERSITY_OUTSIDE_STATE'
    },
    {
      name: 'Students from the Same University',
      value: 'STUDENTS_FROM_THE_SAME_UNIVERSITY'
    },
    {
      name: 'Students from other University With in State',
      value: 'STUDENTS_FROM_OTHER_UNIVERSITY_WITH_IN_State'
    },
    {
      name: 'Other Countries',
      value: 'OTHER_COUNTRIES'
    }
  ];

  static freeLocations = [];

  static questionCo: any = [
    {
      name: 'CO1',
      value: 'CO1'
    },
    {
      name: 'CO2',
      value: 'CO2'
    },
    {
      name: 'CO3',
      value: 'CO3'
    },
    {
      name: 'CO4',
      value: 'CO4'
    },
    {
      name: 'CO5',
      value: 'CO5'
    },
    {
      name: 'CO6',
      value: 'CO6'
    }
  ];

  static paymentStatus: any = [
    {
      name: 'AFTER APPROVAL',
      value: 'AFTER_APPROVAL'
    },
    {
      name: 'BEFORE APPROVAL',
      value: 'BEFORE_APPROVAL'
    }
  ];

  static miscellaneousFeeTypes: any = [
    {
      name: 'Other Fee',
      value: 'OTHER_FEE'
    },
    /*{
      name: 'Migration Certificate',
      value: 'MIGRATION_CERTIFICATE'
    },*/
    {
      name: 'Examination Fee',
      value: 'EXAMINATION_FEE'
    },
    {
      name: 'Prospectus Fee',
      value: 'PROSPECTUS_FEE'
    },
    {
      name: 'Revaluation',
      value: 'REVALUATION'
    },
    /*{
      name: 'Provisional Certificate',
      value: 'PROVISIONAL_CERTIFICATE'
    },*/
    {
      name: 'Fine',
      value: 'FINE'
    },
    {
      name: 'Hostel Stay',
      value: 'HOSTEL_STAY'
    },
    {
      name: 'ID Card',
      value: 'ID_CARD'
    },
    /*{
      name: 'Character Certificate',
      value: 'CHARACTER_CERTIFICATE'
    },*/
    {
      name: 'Re-Checking',
      value: 'RE_CHECKING'
    },
    /*{
      name: 'Duplicate DMC',
      value: 'DUPLICATE_DMC'
    },
    {
      name: 'Degree Fee',
      value: 'DEGREE_FEE'
    },*/
    {
      name: 'Convocation Fee',
      value: 'CONVOCATION_FEE'
    },
    {
      name: 'Uniform',
      value: 'UNIFORM'
    },
    {
      name: 'Alumni Registration',
      value: 'ALUMNI_REGISTRATION'
    },
    /*{
      name: 'Bona Fide Fee',
      value: 'BONA_FIDE_FEE'
    },*/
    {
      name: 'Allegation',
      value: 'ALLEGATION'
    }
  ];

  static hours: any = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12'
  ];

  static minutes: any = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '60'
  ];
  static finalExamTermType: any = [
    {
      name: 'THEORY',
      value: '3'
    },
    {
      name: 'PRACTICAL',
      value: '4'
    },
    {
      name: 'MINOR PROJECT',
      value: '5'
    },
    {
      name: 'MAJOR PROJECT',
      value: '6'
    },
    {
      name: 'SEMINAR',
      value: '7'
    },
    {
      name: 'Dissertation',
      value: '8'
    },
    {
      name: 'Training',
      value: '9'
    },
    {
      name: 'External',
      value: '9'
    }
  ];

  static semesters: any = [
    {
      name: 'First',
      value: '1'
    },
    {
      name: 'Second',
      value: '2'
    },
    {
      name: 'Third',
      value: '3'
    },
    {
      name: 'Fourth',
      value: '4'
    },
    {
      name: 'Fifth',
      value: '5'
    },
    {
      name: 'Sixth',
      value: '6'
    },
    {
      name: 'Seventh',
      value: '7'
    },
    {
      name: 'Eighth',
      value: '8'
    },
    {
      name: 'Ninth',
      value: '9'
    },
    {
      name: 'Tenth',
      value: '10'
    }
  ];

  static designationList: any = [
    'HOD',
    'VICE_PRINCIPAL',
    'PRINCIPAL',
    'DEAN',
    'REGISTRAR',
    'HR',
    'PRO_VC',
    'VC'
  ];

  static designation_statues: any = [
    {
      name: 'Normal',
      value: 'NORMAL'
    },
    {
      name: 'HOD',
      value: 'HOD'
    },
    {
      name: 'Registrar',
      value: 'REGISTRAR'
    },
    {
      name: 'HR',
      value: 'HR'
    },
    {
      name: 'Accountant',
      value: 'ACCOUNTANT'
    },
    {
      name: 'PRO VC',
      value: 'PRO_VC'
    },
    {
      name: 'Chief Hostel Warden',
      value: 'CHIEF_HOSTEL_WARDEN'
    },
    {
      name: 'Dean',
      value: 'DEAN'
    },
    {
      name: 'Vice Principal',
      value: 'VICE_PRINCIPAL'
    },
    {
      name: 'Principal',
      value: 'PRINCIPAL'
    },
    {
      name: 'Dean Academic Affair',
      value: 'DEAN_ACADEMIC_AFFAIR'
    },
    {
      name: 'Campus Officer',
      value: 'CAMPUS_OFFICER'
    },
    {
      name: 'Supervisor',
      value: 'SUPERVISOR'
    },
    {
      name: 'Senior Supervisor',
      value: 'SENIOR_SUPERVISOR'
    },
    {
      name: 'VC',
      value: 'VC'
    }
  ];

  static employee_statuses: any = [
    {
      name: 'Teaching',
      value: 'TEACHING'
    },
    {
      name: 'Non Teaching',
      value: 'NON_TEACHING'
    },
    {
      name: 'Supporting Staff',
      value: 'SUPPORTING_STAFF'
    },
    {
      name: 'Director',
      value: 'DIRECTOR'
    },
    {
      name: 'Visiting Faculty',
      value: 'VISITING_FACULTY'
    },
    {
      name: 'Other',
      value: 'OTHER'
    }
  ];

  static documentTypes: any = [
    {
      name: 'Bona Fide',
      value: 'BONA_FIDE',
      amount: 1
    },
    {
      name: 'Migration Certificate',
      value: 'MIGRATION_CERTIFICATE',
      amount: 100
    },
    {
      name: 'Provisional Certificate',
      value: 'PROVISIONAL_CERTIFICATE',
      amount: 100
    },
    {
      name: 'Character Certificate',
      value: 'CHARACTER_CERTIFICATE',
      amount: 100
    },
    {
      name: 'Duplicate DMC',
      value: 'DUPLICATE_DMC',
      amount: 100
    },
    {
      name: 'Degree',
      value: 'DEGREE',
      amount: 100
    },
    {
      name: 'Marksheet',
      value: 'MARKSHEET',
      amount: 100
    }
  ];

  static grades: any = [
    {
      name: 'S+',
      value: 'S+'
    },
    {
      name: 'S',
      value: 'S'
    },
    {
      name: 'O++',
      value: 'O++'
    },
    {
      name: 'O+',
      value: 'O+'
    },
    {
      name: 'O',
      value: 'O'
    },
    {
      name: 'A++',
      value: 'A++'
    },
    {
      name: 'A+',
      value: 'A+'
    },
    {
      name: 'A',
      value: 'A'
    },
    {
      name: 'B+',
      value: 'B+'
    },
    {
      name: 'B',
      value: 'B'
    },
    {
      name: 'C',
      value: 'C'
    }
  ];

  static resultStatues: any = [
    {
      name: 'Pass',
      value: 'P'
    },
    {
      name: 'Fail',
      value: 'F'
    },
    {
      name: 'Absent',
      value: 'AB'
    },
    {
      name: 'Reappear (External)',
      value: 'RP(E)'
    },
    {
      name: 'Reappear (Internal)',
      value: 'RP(I)'
    },
    {
      name: 'Reappear (Internal & External)',
      value: 'RP(T)'
    },
    {
      name: 'Reappear',
      value: 'R'
    }
  ];
}
